// extracted by mini-css-extract-plugin
export default {"page":"dR-z","cartModal":"eR-z","checkout":"fR-z","placeholder":"gR-z","account":"hR-z"};